// TODO: find some better name for this action
import type { Page } from '@sveltejs/kit';

export const linkToggle = (node: HTMLAnchorElement, page: Page) => {
	if (!page.data.respHub) throw new Error('linkToggle: page.data.respHub is undefined');
	const href = node.getAttribute('href');

	if (!href || page.url.hostname == 'localhost') return;

	const link = new URL(href, page.url.origin);

	const hub = page.data.respHub.hub;
	const testMode = page.url.searchParams.has('testMode');

	if (testMode || hub.settings.feature.nextGenUI) {
		link.searchParams.set('app', 'svelte');
	} else {
		link.searchParams.set('app', 'bluesuede');
		node.setAttribute('data-sveltekit-reload', '');
	}
	node.setAttribute('href', link.toString());
};
